import React from "react";
import {parseFieldsList} from "../../../shared/utils/format";
import Tag from "../../../shared/components/Tag";

/**
 * The fields of a device type as tags. `fieldsList` is the API's
 * comma-separated string (or null).
 *
 * @param {{fieldsList?: string|null, empty?: React.ReactNode}} props
 */
const FieldTags = ({fieldsList, empty = <span className="text-muted">Sem campos.</span>}) => {
    const names = parseFieldsList(fieldsList);
    if (!names.length) return <>{empty}</>;
    return (
        <span className="d-inline-flex flex-wrap gap-1 align-middle">
            {names.map((name) => (
                <Tag key={name}>{name}</Tag>
            ))}
        </span>
    );
};

export default FieldTags;
